<template>
    <el-dialog
        :title="text"
        width="25%"
        :visible="true"
        :before-close="handleClose">
        <el-form ref="form" :model="form" label-width="100px" :rules="rules">
            <el-form-item label="选择业务员" prop="id" >
                <UserSelect1 v-model="form.id"  @change="UserHandleChange"></UserSelect1>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" >
            <el-button @click="handleClose()" >取消</el-button>
            <el-button type="primary" @click="submitForm('form')" >确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import UserService from "~/services/user"
import UserSelect1 from "~/widgets/UserSelectCorp.vue";
export default {
    data() {
        return {
            isShow: false,
            value: "",
            userList: [],
            form: {
                id: ""
            },
            rules: {
                id: [
                    {
                        required: true,
                        message: "请选择业务员"
                    }
                ]
            }   
        }
    },
    props: {
        text: String,
        actionYes: null
    },
    components: {
        UserSelect1
    },
    created() {
        this.getInfo();
    },
    methods: {
        // 获取业务员信息
        getInfo(params = {}) {
            return UserService.getAll(params).then( res => {
                this.userList = res.data;
            })
        },
        handleClose() {
            this.$refs['form'].resetFields();
            this.close();
        },
        close() {
            this.isShow = false;
            this.$emit("changeShow", this.isShow);
        },

        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if(valid) {
                    if(typeof this.actionYes === 'function') {
                        this.actionYes(this.form.id);
                    } 
                    this.close();
                } else {
                    return false;
                }
            })
        },

        //业务员姓名远程搜索组件赋值
        UserHandleChange(value) {
            this.form.id = value;
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/views/clue/dialog/assignClueDialog.vue